/* eslint-disable class-methods-use-this */
class ElementDataStore {
  constructor(initialData) {
    this.data = {};
    this.subscribers = {
      update: []
    };
  }

  trigger(trigger, data) {
    this.subscribers[trigger].forEach(handler => {
      handler(data);
    });
  }

  set(data) {
    this.data = data;
  }

  subscribe(trigger, handler) {
    if (!this.subscribers[trigger]) this.subscribers[trigger] = [];
    this.subscribers[trigger].push(handler);
  }

  unsubscribe(trigger, handler) {
    const listeners = this.subscribers[trigger];
    if (listeners) {
      const filtered = listeners.filter(fn => fn !== handler);
      this.subscribers[trigger] = filtered;
    }
  }

  update(data) {
    this.data = data;
    this.trigger("update", data);
  }
}

export default ElementDataStore;
